import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";
import { logsConfig, rumConfig } from "./config";

export const DatadogProvider = () => {
  useEffect(() => {
    if (!datadogRum.getInitConfiguration()) datadogRum.init(rumConfig);
    if (!datadogLogs.getInitConfiguration()) datadogLogs.init(logsConfig);
  }, []);

  return null;
};
